<script lang="ts">
	import PaginatorLink from './PaginatorLink.svelte'
	import { Dropdown } from '@repo/ui'
	import { DropdownBox } from '@repo/ui'
	import { createEventDispatcher } from 'svelte'
	import { preventDefault } from 'svelte/legacy'

	interface Props {
		pages: number
		currentPage: number
	}

	let { pages, currentPage }: Props = $props()

	const dispatch = createEventDispatcher()

	let newPage: number = $state(currentPage + 1)

	function handlePageChange() {
		if (Number.isInteger(newPage)) {
			isOpen = false
			dispatch('submit', newPage)
		}
	}

	let isOpen: boolean = $state(false)
</script>

<Dropdown bind:opened={isOpen}>
	{#snippet placeholder({ onclick })}
		<PaginatorLink name="pagination-current" active {onclick}>
			{currentPage + 1}
		</PaginatorLink>
	{/snippet}
	<DropdownBox>
		<form onsubmit={preventDefault(handlePageChange)}>
			<input
				class="rounded-sm border border-gray-300 px-1"
				max={pages + 1}
				min="1"
				onblur={handlePageChange}
				type="number"
				bind:value={newPage}
			/>
		</form>
	</DropdownBox>
</Dropdown>
